import { Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';
import { IChallengeReasonsEnum } from '../../../account.data';

const SCHEMA = Object.freeze({
  ID: '',
  REASON: IChallengeReasonsEnum,
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class Challenge extends Record(RECORD) {
  constructor(props?: any) {
    super(props);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get reason(): IChallengeReasonsEnum {
    return this.get(KEYS.REASON);
  }
}
